var NotificationTypes = /* @__PURE__ */ ((NotificationTypes2) => {
  NotificationTypes2["ALERT"] = "alert";
  NotificationTypes2["CRITICAL"] = "critical";
  NotificationTypes2["SUCCESS"] = "success";
  NotificationTypes2["GENERAL"] = "general";
  return NotificationTypes2;
})(NotificationTypes || {});
export {
  NotificationTypes
};
